import logger from '../debug';

type BaseType<T> = T extends Promise<infer B> ? B : never;

export const withExceptionHandling =
  <T extends (...args: any[]) => Promise<any>>(
    action: T,
    throwOnError: boolean,
  ): ((...args: Parameters<T>) => Promise<BaseType<ReturnType<T>> | undefined>) =>
  async (...args) => {
    try {
      const result = await action(...args);
      return result;
    } catch (e) {
      logger.warn('tracker failure', e);

      if (throwOnError) {
        throw e;
      }
    }
  };

export const withExceptionHandlingSync =
  <T extends (...args: any[]) => any>(
    action: T,
    throwOnError: boolean,
  ): ((...args: Parameters<T>) => ReturnType<T> | undefined) =>
  (...args) => {
    try {
      return action(...args);
    } catch (e) {
      logger.warn('tracker failure', e);

      if (throwOnError) {
        throw e;
      }
    }
  };
